import React, { useEffect, createElement } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import LogoSection from './components/LogoSection';
import WhoThisIsForSection from './components/WhoThisIsForSection';
import TaleOfTwoOwnersSection from './components/TaleOfTwoOwnersSection';
import TeamSection from './components/TeamSection';
import TimelineSection from './components/TimelineSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ThankYouPage from './pages/ThankYouPage';
import HealthcareClinicsPage from './pages/HealthcareClinicsPage';
import BookingPage from './pages/BookingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
// Sprint page component (formerly HomePage)
const SprintPage = () => <>
    <HeroSection data-id="element-0" />
    <LogoSection data-id="element-1" />
    <WhoThisIsForSection data-id="element-2" />
    <TaleOfTwoOwnersSection data-id="element-3" />
    <TeamSection data-id="element-4" />
    <TimelineSection data-id="element-5" />
    <FAQSection data-id="element-6" />
  </>;
export function App() {
  return <HelmetProvider data-id="element-7">
      <BrowserRouter data-id="element-8">
        <ScrollToTop data-id="element-9" />
        <div className="flex flex-col min-h-screen bg-white" data-id="element-10">
          <Helmet data-id="element-11">
            <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-12" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-13" />
            <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Libre+Caslon+Text:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" data-id="element-14" />
            <script src="https://fast.wistia.com/player.js" async data-id="element-15"></script>
            <script src="https://fast.wistia.com/embed/me9xxd1792.js" async type="module" data-id="element-16"></script>
            <script src="//embed.typeform.com/next/embed.js" async data-id="element-17"></script>
            {/* Meta Pixel Code */}
            <script data-id="element-18">
              {`
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '1987279828520454');
                fbq('track', 'PageView');
              `}
            </script>
            <noscript data-id="element-19">
              {`<img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=1987279828520454&ev=PageView&noscript=1"
              />`}
            </noscript>
            <style data-id="element-20">{`
              @import url("https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Libre+Caslon+Text:ital,wght@0,400;0,700;1,400&display=swap");
              h1, h2, h3, h4, h5, h6 {
                font-family: "Times New Roman", Times, serif !important;
                font-weight: 700 !important;
                font-style: normal !important;
              }
              wistia-player[media-id='me9xxd1792']:not(:defined) { 
                background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/me9xxd1792/swatch'); 
                display: block; 
                filter: blur(5px); 
                padding-top:56.25%; 
              }
            `}</style>
          </Helmet>
          <Routes data-id="element-21">
            <Route path="/" element={<main className="flex-grow" data-id="element-23">
                  <SprintPage data-id="element-24" />
                </main>} data-id="element-22" />
            <Route path="/thankyoupage" element={<ThankYouPage data-id="element-26" />} data-id="element-25" />
            <Route path="/healthcareclinics" element={<HealthcareClinicsPage data-id="element-28" />} data-id="element-27" />
            <Route path="/bookingpage" element={<BookingPage data-id="element-30" />} data-id="element-29" />
            <Route path="/privacypage" element={<PrivacyPage data-id="element-32" />} data-id="element-31" />
            <Route path="/termsofservice" element={<TermsOfServicePage data-id="element-34" />} data-id="element-33" />
          </Routes>
          <Routes data-id="element-35">
            <Route path="/" element={<Footer data-id="element-37" />} data-id="element-36" />
            <Route path="/healthcareclinics" element={<Footer data-id="element-39" />} data-id="element-38" />
            <Route path="/bookingpage" element={<Footer data-id="element-41" />} data-id="element-40" />
          </Routes>
        </div>
      </BrowserRouter>
    </HelmetProvider>;
}